import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export default function CollapsibleSection({ title, icon: Icon, defaultOpen = false, badge, testId, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div data-testid={testId} className="bg-white dark:bg-[#0F1419] border border-slate-200 dark:border-white/[0.06] rounded-xl overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between p-4 hover:bg-slate-50 dark:hover:bg-white/[0.02] transition-colors"
      >
        <div className="flex items-center gap-2.5">
          {Icon && <Icon className="w-4 h-4 text-slate-400" />}
          <span className="font-semibold text-sm text-slate-900 dark:text-white">{title}</span>
          {badge && (
            <span className="px-1.5 py-0.5 text-[10px] font-bold rounded bg-slate-100 dark:bg-white/10 text-slate-500 dark:text-slate-400">
              {badge}
            </span>
          )}
        </div>
        <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="px-4 pb-4 border-t border-slate-100 dark:border-white/[0.04] pt-3">
          {children}
        </div>
      )}
    </div>
  );
}
